const doc = [({"NONE":"nein", "LIGHT":"leicht", "MEDIUM":"mittel", "STRONG":"stark", "VERY_STRONG":"sehr stark"})];
module.exports = doc.length <= 1 ? doc[0] : doc;